import script from "./WorkersCompTCPA.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkersCompTCPA.vue?vue&type=script&setup=true&lang=js"

import "./WorkersCompTCPA.vue?vue&type=style&index=0&id=272f77bd&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-272f77bd"]])

export default __exports__